import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUserQuiz, useCreate: useResetQuizSession } = getCRUDHooks({
  entityName: 'quiz',
  get: ({ userId, quizId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).quiz.get(quizId),
  create: ({ userId, quizId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).quiz.id(quizId).reset.create(),
});

// eslint-disable-next-line import/prefer-default-export
export { useUserQuiz, useResetQuizSession };
